import { REQUEST_ALL_SKILLS, RECEIVE_ALL_SKILLS, REQUEST_SKILL, RECEIVE_SKILL, REQUEST_ACTIVITY_SKILLS, RECEIVE_ACTIVITY_SKILLS, REQUEST_ALL_SKILL_GROUPS, RECEIVE_ALL_SKILL_GROUPS, RECEIVE_CREATE_SKILL, RECEIVE_CREATE_SKILL_GROUP, RECEIVE_ADD_SKILL_DETAILS } from '../constants/actionTypes';

const initialState = {
    allSkills: [],
    fetchingAllSkills: true,
    skill: {},
    fetchingSkill: true,
    activitySkills: [],
    fetchingActivitySkills: true,
    skillGroups: [],
    fetchingSkillGroups: true
};

const skills = (state = initialState, action) => {
    switch(action.type) {
        case REQUEST_ALL_SKILLS:
            return {
                ...state,
                fetchingAllSkills: true,
                allSkills: []
            };

        case RECEIVE_ALL_SKILLS:
            return {
                ...state,
                fetchingAllSkills: false,
                allSkills: action.allSkills
            };
        
        case REQUEST_SKILL:
            return {
                ...state,
                fetchingSkill: true,
                skill: {}
            };
        
        case RECEIVE_SKILL:
            return {
                ...state,
                fetchingSkill: false,
                skill: action.skill
            }

        case REQUEST_ACTIVITY_SKILLS:
            return {
                ...state,
                fetchingActivitySkills: true,
                activitySkills: []
            };

        case RECEIVE_ACTIVITY_SKILLS:
            return {
                ...state,
                fetchingActivitySkills: false,
                activitySkills: action.activitySkills
            };

        case REQUEST_ALL_SKILL_GROUPS:
            return {
                ...state,
                fetchingAllSkillGroups: true,
                skillGroups: []
            };
    
        case RECEIVE_ALL_SKILL_GROUPS:
            return {
                ...state,
                fetchingAllSkillGroups: false,
                skillGroups: action.allSkillGroups
            };

        case RECEIVE_CREATE_SKILL:
            return {
                ...state,
                allSkills: [...state.allSkills, action.result]
            }

        case RECEIVE_CREATE_SKILL_GROUP:
            return {
                ...state,
                skillGroups: [...state.skillGroups, action.result]
            }

        case RECEIVE_ADD_SKILL_DETAILS:
            return {
                ...state,
                activitySkills: [...state.activitySkills, action.addedSkillDetails]
            }
        
        default:
            return state;
    }
};

export default skills;



// WEBPACK FOOTER //
// ./src/reducers/skills.js